import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations, LANGUAGES } from "@/i18n/translations";
import { machineTranslations } from "@/i18n/machines";

const LanguageContext = createContext(null);

function getNested(obj, path) {
  return path.split(".").reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), obj);
}

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("eqt_lang") || "en");

  const setLang = useCallback((code) => {
    setLangState(code);
    localStorage.setItem("eqt_lang", code);
  }, []);

  const t = useCallback(
    (path) => {
      const val = getNested(translations[lang], path);
      if (val !== undefined) return val;
      return getNested(translations.en, path) ?? path;
    },
    [lang]
  );

  const machine = useCallback(
    (model) => (machineTranslations[lang] && machineTranslations[lang][model]) || machineTranslations.en[model] || null,
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t, machine, languages: LANGUAGES }), [lang, setLang, t, machine]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
